import React, { useState, useEffect } from 'react'
import {
  Grid,
  FormControl,
  Button,
  Box,
  CircularProgress,
} from '@material-ui/core'
import {
  getIFISbyCountry,
  getCountryByID,
  getMIPYMENotificationRepresentation,
} from '../../../../services/IFI/get'
import { sendNotification } from '../../../../services/Representacion/create'
import './form.scss'
import Swal from 'sweetalert2'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
// import { useFormIFI } from '../../../../../context/IFIContext'
// import Stack from '@mui/material/Stack'
import { useAuthentication } from '../../../../context/authenticationContext'
import { useHistory } from 'react-router-dom'
import { Autocomplete, TextField } from '@mui/material'
import PropTypes from 'prop-types'
import Typography from '@mui/material/Typography'
import MaterialTable from 'material-table'
import ClearIcon from '@mui/icons-material/Clear'
import { deleteNotification } from '../../../../services/IFI/delete'
import { getMIPYMEWithoutRepresentation } from '../../../../services/Representacion/get'
import ExitIcon from '@material-ui/icons/ExitToApp'
import ReactTooltip from 'react-tooltip'

function TabPanel(props) {
  const { children, value, index, ...other } = props

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  )
}

//
TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  }
}

const Form = () => {
  // const { getUsersIfiDataTable } = useFormIFI()
  const history = useHistory()
  const [IFIList, setIFIList] = useState([])
  const [MIPYMEList, setMIPYMEList] = useState([])
  const [Countries, setCountries] = useState([])
  const [loading, setLoading] = useState(true)

  const [value, setValue] = React.useState(0)
  const handleChange = (event, newValue) => {
    setValue(newValue)
  }

  const handleDeleteNotification = async (IdNotification) => {
    try {
      const response = await deleteNotification(IdNotification)
      if (response.Success) {
        getMIPYMES()
        Swal.fire({
          title: 'Solicitud cancelada correctamente!',
          icon: 'success',
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Entendido',
        })
      } else
        Swal.fire({
          title: 'Ocurrió un error al cancelar su solicitud',
          text: response.Message,
          icon: 'error',
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Entendido',
        })
      getNotification()
    } catch (error) {
      console.log(error)
    }
  }

  const columns = [
    {
      title: 'MIPYME',
      field: 'MiPymeName',
      sorting: true,
      filtering: true,
      // cellStyle: { background: '#009688' },
      // headerStyle: { color: '#fff' },
    },
    {
      title: 'IFI',
      field: 'IfiName',
      sorting: true,
      filtering: true,
      // cellStyle: { background: '#009688' },
      // headerStyle: { color: '#fff' },
    },
  ]

  //
  const { userCountry, userIDB2C } = useAuthentication()
  const [body, setBody] = useState({
    IdIFi: '',
    IdMiPyme: '',
  })
  const [TableForms, setTableForms] = useState([])

  const getMIPYMES = async () => {
    try {
      const response = await getMIPYMEWithoutRepresentation(userIDB2C)
      if (response.Success) setMIPYMEList(response.Data)
    } catch (error) {
      console.log(error)
    }
  }

  const getNotification = async () => {
    try {
      const response = await getMIPYMENotificationRepresentation(userIDB2C)
      if (response.Success) setTableForms(response.Data)
    } catch (error) {
      console.log(error)
    }
  }

  const getIFIS = async () => {
    try {
      const response = await getIFISbyCountry(userCountry)
      setIFIList(response.Data)
      setLoading(false)
    } catch (error) {
      console.log(error)
      setLoading(false)
    }
  }
  const getCountries = async () => {
    try {
      const response = await getCountryByID(userCountry)
      setCountries(response.Data)
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    getMIPYMES()
    getIFIS()
    getCountries()
    getNotification()
  }, [])

  const handleGuardar = async () => {
    const response = await sendNotification(
      body.IdIFi,
      userIDB2C,
      body.IdMiPyme,
    )
    if (response.Code === 200) {
      Swal.fire({
        title: '¡Solicitud Enviada exitosamente!',
        icon: 'success',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Entendido',
      })
      handleClose()
    } else {
      Swal.fire({
        title: 'Ocurrió un error al enviar su solicitud',
        text: `Contacte con el administrador`,
        icon: 'error',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Entendido',
      })
    }
  }

  const handleClose = () => {
    history.push('/')
  }

  // const SelectCountry = (f) => {
  //   const data = IFIList.filter((e) => e.IdIFI === f.target.value)
  //   setBody({
  //     ...body,
  //     IdIFi: f.target.value,
  //     IdCountry: data[0].IdCountry,
  //   })
  // }

  const cancelForm = () => {
    history.push('/')
  }

  return (
    <>
      {!loading ? (
        <form id="transfers-form">
          <Grid className="miContainer">
            <Grid className="miForm">
              <Grid
                container
                spacing={1}
                style={{ paddingRight: '2%' }}
                justifyContent="flex-end"
              >
                <div
                  data-tip
                  data-for="exitPop"
                  style={{
                    backgroundColor: 'red',
                    color: '#fff',
                    width: '40px',
                    display: 'flex',
                    alignItems: 'right',
                    align: 'flex-end',
                    justifyContent: 'center',
                    borderRadius: '4px',
                    padding: '5px',
                    cursor: 'pointer',
                    position: 'absolute',
                  }}
                  onClick={() => cancelForm()}
                >
                  <ExitIcon style={{ transform: 'scaleX(-1)' }} />
                  <ReactTooltip
                    id="exitPop"
                    effect="solid"
                    backgroundColor="red"
                  >
                    <span>Regresar</span>
                  </ReactTooltip>
                </div>
              </Grid>
              <Grid container className="input__container">
                <Grid item xs={12} sm={12} md={12}>
                  <h1
                    style={{
                      padding: '0px',
                      margin: '0px',
                    }}
                  >
                    Solicitud Representación a IFI
                  </h1>
                  <p>
                    Rellene la información requerida para solicitar
                    representación de una IFI
                  </p>
                </Grid>

                <Grid item xs={12} sm={12} md={12}>
                  <Box sx={{ width: '100%' }}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                      <Tabs
                        value={value}
                        onChange={handleChange}
                        aria-label="basic tabs example"
                      >
                        <Tab label="Por solicitar" {...a11yProps(0)} />
                        <Tab
                          label="Pendientes de aprobación"
                          {...a11yProps(1)}
                        />
                      </Tabs>
                    </Box>
                    <TabPanel value={value} index={0}>
                      <Grid
                        container
                        spacing={1}
                        style={{
                          display: 'flex',
                          justifyContent: 'flex-end',
                          alignItems: 'flex-end',
                        }}
                      >
                        <Grid
                          item
                          xs={12}
                          sm={12}
                          md={12}
                          style={{ marginTop: '1%' }}
                        >
                          <Grid container spacing={1}>
                            <Grid item xs={12} sm={12} md={12}>
                              <label className="responsiveLabel">
                                Nombre de la IFI
                              </label>
                            </Grid>
                            <Grid item xs={12} sm={12} md={12}>
                              <FormControl fullWidth>
                                {/* <Select
                            id="IdIFi"
                            name="IdIFi"
                            variant="outlined"
                            value={body.IdIFi}
                            displayEmpty={true}
                            onChange={(e) => {
                              setBody({
                                ...body,
                                IdIFi: e.target.value,
                              })
                              // SelectCountry(e)
                            }}
                            required
                          >
                            <MenuItem disabled value="">
                              Seleccione nombre de la IFI
                            </MenuItem>
                            {IFIList &&
                              IFIList.map((item, key) => (
                                <MenuItem key={key} value={item.IdIFI}>
                                  {item.BusinessName}
                                </MenuItem>
                              ))}
                          </Select> */}
                                <Autocomplete
                                  getOptionLabel={(option) =>
                                    // `${option.TaxRegistration}` +
                                    // ' / ' +
                                    // option.BusinessName
                                    `${option.BusinessName}`
                                  }
                                  disablePortal
                                  placeholder="Seleccione una IFI"
                                  id="combo-box-demo"
                                  options={IFIList}
                                  // value={result[0]}
                                  sx={{ width: '100%' }}
                                  renderInput={(params) => (
                                    <TextField {...params} />
                                  )}
                                  onChange={(e, value) => {
                                    setBody({
                                      ...body,
                                      IdIFi: value.IdIFI,
                                    })
                                  }}
                                />
                              </FormControl>
                            </Grid>
                          </Grid>
                        </Grid>

                        <Grid item xs={12} sm={12} md={12}>
                          <Grid container spacing={1}>
                            <Grid item xs={12} sm={12} md={12}>
                              <label className="responsiveLabel">MIPYME</label>
                            </Grid>
                            <Grid item xs={12} sm={12} md={12}>
                              <FormControl fullWidth>
                                {/* <Select
                            id="IdMiPyme"
                            name="IdMiPyme"
                            variant="outlined"
                            value={body.IdMiPyme}
                            displayEmpty={true}
                            onChange={(e) => {
                              setBody({
                                ...body,
                                IdMiPyme: e.target.value,
                              })
                              // SelectCountry(e)
                            }}
                            required
                          >
                            <MenuItem disabled value="">
                              Seleccione MIPYME
                            </MenuItem>
                            {MIPYMEList &&
                              MIPYMEList.map((item, key) => (
                                <MenuItem key={key} value={item.IdMiPyme}>
                                  {item.BusinessName}
                                </MenuItem>
                              ))}
                          </Select> */}
                                <Autocomplete
                                  getOptionLabel={(option) =>
                                    // `${option.TaxRegistration}` +
                                    // ' / ' +
                                    // option.BusinessName
                                    `${option.BusinessName}`
                                  }
                                  disablePortal
                                  placeholder="Seleccione una MIPYME"
                                  id="combo-box-demo"
                                  options={MIPYMEList}
                                  sx={{ width: '100%' }}
                                  renderInput={(params) => (
                                    <TextField {...params} />
                                  )}
                                  onChange={(e, value) => {
                                    setBody({
                                      ...body,
                                      IdMiPyme: value.IdMiPyme,
                                    })
                                  }}
                                />
                              </FormControl>
                            </Grid>
                          </Grid>
                        </Grid>

                        <Grid item xs={12} sm={12} md={12}>
                          <Grid container spacing={1}>
                            <Grid item xs={12} sm={12} md={12}>
                              <label className="responsiveLabel">País</label>
                            </Grid>
                            <Grid item xs={12} sm={12} md={12}>
                              <FormControl fullWidth>
                                <TextField
                                  id="Country"
                                  name="Country"
                                  type="text"
                                  placeholder="País"
                                  variant="outlined"
                                  sx={{ width: 220 }}
                                  inputProps={{ maxLength: 20 }}
                                  value={Countries.LargeName}
                                  disabled
                                />
                              </FormControl>
                            </Grid>
                          </Grid>
                        </Grid>

                        <Grid className="buttonsPYME">
                          <Button
                            className="cancelButton"
                            onClick={() => handleClose()}
                          >
                            Cancelar
                          </Button>
                          <Button
                            className="confirmButton"
                            onClick={handleGuardar}
                          >
                            Confirmar
                          </Button>
                        </Grid>
                      </Grid>
                    </TabPanel>
                    <TabPanel value={value} index={1}>
                      <Grid container spacing={1}>
                        <Grid item xs={12} sm={12} md={12}>
                          <MaterialTable
                            columns={columns}
                            data={TableForms}
                            actions={[
                              {
                                icon: () => <ClearIcon color="error" />,
                                tooltip: 'Cancelar solicitud',
                                onClick: (event, rowData) => {
                                  // handleOpen(true)
                                  handleDeleteNotification(
                                    rowData.IdNotification,
                                  )
                                  // setIdNotification(rowData.IdNotification)
                                },
                              },
                            ]}
                            onSelectionChange={(selectedRows) =>
                              console.log(selectedRows)
                            }
                            options={{
                              sorting: true,
                              search: true,
                              searchFieldAlignment: 'right',
                              searchAutoFocus: true,
                              searchFieldVariant: 'standard',
                              filtering: true,
                              paging: true,
                              pageSizeOptions: [2, 5, 10, 20],
                              pageSize: 5,
                              paginationType: 'stepped',
                              showFirstLastPageButtons: false,
                              paginationPosition: 'bottom',
                              exportButton: false,
                              exportAllData: true,
                              exportFileName: 'TableData',
                              // addRowPosition: 'first',
                              actionsColumnIndex: -1,
                              selection: false,
                              showSelectAllCheckbox: false,
                              showTextRowsSelected: false,
                              selectionProps: (rowData) => ({
                                disabled: rowData.age == null,
                                // color:"primary"
                              }),
                              // grouping: true,
                              columnsButton: false,
                              rowStyle: (data, index) =>
                                index % 2 === 0
                                  ? { background: '#f5f5f5' }
                                  : null,
                              headerStyle: {
                                background: '#014b96',
                                color: '#fff',
                              },
                            }}
                            localization={{
                              body: {
                                editRow: {
                                  deleteText:
                                    '¿Está seguro de eliminar el registro?',
                                },
                                emptyDataSourceMessage:
                                  'No hay registros a desplegar',
                              },
                              header: {
                                actions: 'Acciones',
                              },
                              toolbar: {
                                searchPlaceholder: 'Buscar',
                              },
                            }}
                            title=" "
                          />
                        </Grid>
                      </Grid>
                    </TabPanel>
                  </Box>
                </Grid>
                {/* Aprobacion */}

                {/* fin aprobacion */}
              </Grid>
            </Grid>
          </Grid>
        </form>
      ) : (
        <Box className="loadingEditContainer">
          <Grid className="loadingSub">
            <CircularProgress />
          </Grid>
        </Box>
      )}
    </>
  )
}

export default Form
